<div class="general-container">
  <div class="body-container">
    <ng-container *ngFor="let option of options; index as i; last as isLast">
      <app-each-billing-option
        [billing]="option"
        [isLast]="isLast"
        [totalItems]="options.length"
        (selectBilling)="selectOption($event)"
        (edit)="edit.emit($event)"
        (remove)="remove.emit(option._id)">
      </app-each-billing-option>
    </ng-container>
  </div>
  <div class="new-person-container" [class.without-contact]="isInvalidContactInfo">
    <app-new-billing-data
      [isModal]="!isMobile"
      [icon]="icons.Add"
      [isDisabled]="isInvalidContactInfo"
      (toggleList)="toggleList.emit()">
    </app-new-billing-data>
  </div>
  <ng-container *ngIf="isInvalidContactInfo">
    <div class="error-with-contact-info">
      {{ 'BOOKING_MODULE.BILLING.MANDATORY_BILLING_CONTACT_SECTION' | transloco }}
    </div>
  </ng-container>
</div>
